module.exports = __webpack_public_path__ + "static/media/token_metrics.ef2968e7.jpeg";